var PRECISE_DRAW_DELAY = 250;
var DRAW_FRAME_RATE = 10; //max plot/sec

var R_EARTH = 6371.2;
var R_OUTER_CORE = 3485;
var R_INNER_CORE = 1216;

import {GlobeController, getLibPath} from './controller/globeController.js';
import {ScalarData, scalarDataFromJson} from './model/scalarData.js';
import {VectorData, vectorDataFromJson, scalarDataFromVectorJson} from './model/vectorData.js';
import { ColorScale, ColorScales } from './model/colorScales.js';

var libPath = getLibPath();
console.log("LIBPATH",libPath);
var colorScales = new ColorScales();
require("file-loader?name=[name].[ext]&outputPath=view/!./view/parameters.html");
require("file-loader?name=[name].[ext]&outputPath=view/!./view/pointinfo.html");
require("file-loader?name=[name].[ext]&outputPath=view/!./view/videoexport.html");

require("file-loader?name=[name].[ext]&outputPath=data/!./data/50m.json");
require("file-loader?name=[name].[ext]&outputPath=data/!./data/110m.json");

require("file-loader?name=[name].[ext]!./css/earthcorevisu.css");

// Default export
export {
  GlobeController,
  ScalarData,
  scalarDataFromJson,
  scalarDataFromVectorJson,
  VectorData,
  vectorDataFromJson,
  colorScales,
  ColorScale,
  PRECISE_DRAW_DELAY,
  DRAW_FRAME_RATE,
  R_EARTH,
  R_OUTER_CORE,
  R_INNER_CORE,
  libPath,
}



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 12
// module chunks = 0